<template>
  <main class="add-company-module">
    <el-form-item :label="config.label">
      <el-select
        v-model="ruleForm[keyName]"
        filterable
        clearable
        remote
        @focus="focus"
        :remote-method="filterMethod"
        :no-match-text="'无匹配数据'"
        placeholder="请选择"
      >
        <div class="add-company-self-options">
          <el-option
            :disabled="item.label === '无匹配数据'"
            v-for="item in options"
            :key="item.val"
            :label="item.label"
            :value="item.val"
          >
          </el-option>
        </div>
        <div v-if="noOptions" class="add-company-wrapper">
          试试<span class="add-btn" @click="addCompany">添加所属公司</span>吧!
        </div>
      </el-select>
    </el-form-item>
    <el-dialog
      :title="config.title"
      :append-to-body="true"
      :visible.sync="dialogFormVisible"
      class="self-add-company"
      width="420px"
    >
      <el-form :model="companyForm" label-width="80px" :rules="rules">
        <el-form-item label="城市" prop="cityName">
          <el-select
            v-model="companyForm.cityName"
            filterable
            clearable
            placeholder="请选择城市"
          >
            <el-option
              v-for="item in cityList"
              :key="item.cityCode"
              :value="item.cityName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" style="margin:24px 0;" prop="name">
          <el-input v-model="companyForm.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="createCompany">保 存</el-button>
      </div>
    </el-dialog>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import cookie from '../../cookie/cookie'
export default {
  created() {
    this.getUserName()
  },
  data() {
    return {
      // showAddCompanyBtn: false, // 是否显示添加所属公司按钮
      dialogFormVisible: false,
      companyForm: {},
      rules: {
        cityName: [{ required: true, message: '请选择城市' }],
        name: [{ required: true, message: '请输入公司名称' }],
      },
      options: [],
      usernameZh: '',
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return {
          label: '',
          title: '添加所属公司',
          type: 'SIGN',
          config: '',
        }
      },
    },
    ruleForm: {
      type: Object,
    },
    keyName: {
      type: String,
    },
  },
  computed: {
    ...mapState('vehicle', ['searchList', 'noOptions']),
    ...mapState('info', ['cityList']),
  },
  methods: {
    focus() {
      this.getCompanyList()
    },
    getUserName() {
      this.usernameZh = cookie.getCookie('usernameZh')
    },
    getCompanyList(key) {
      this.$store.dispatch('vehicle/GET_DRIVEROPERATOR_LIST', {
        searchType: this.config.searchType || 'SIGNCOMPANY',
        key: key || '',
      })
    },
    filterMethod(value) {
      const companyList = this.searchList
      this.getCompanyList(value)
    },
    createCompany() {
      this.$request({
        url: '/proxy/api/company/add',
        method: 'post',
        data: {
          name: this.companyForm.name,
          cityName: this.companyForm.cityName,
          creator: this.usernameZh,
          type: this.config.type,
        },
      }).then((res) => {
        if (!res.errorCode) {
          this.$store.dispatch('vehicle/GET_DRIVEROPERATOR_LIST', {
            searchType: this.config.searchType || 'SIGNCOMPANY',
          })
          this.dialogFormVisible = false
          this.$message({
            message: '添加公司成功',
            type: 'success',
          })
        }
        this.companyForm = Object.assign(
          {},
          { name: '', cityName: this.companyForm.cityName }
        )
      })
    },
    cancel() {
      this.dialogFormVisible = false
      this.companyForm = {}
    },
    addCompany() {
      this.dialogFormVisible = true
    },
  },
  watch: {
    searchList: function(val) {
      this.options = val
      // this.showAddCompanyBtn = false
      if (this.noOptions) {
        this.options = [{ label: '无匹配数据', val: '无匹配数据' }]
      }
    },
    noOptions: function(val) {
      if (val) {
        this.options = [{ label: '无匹配数据', val: '无匹配数据' }]
        // this.showAddCompanyBtn = true
      }
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common-color.styl'
.add-company-wrapper
  width 100%
  text-align center
  font-size 14px
  color gray04
  .add-btn
    color primary-color
    font-family  PingFangSC-Medium
    cursor pointer
.add-company-self-options
  .is-disabled
    cursor auto
    display flex
    justify-content center
    color gray04
    font-weight 400
.self-add-company
  .el-input__inner
    width 230px
</style>
